<template>
  <ButtonComponent
    :text="text"
    :simple="true"
    :fakeAfter="false"
    :styleText="styleText"
    :styleButton="styleButton"
  />
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./ButtonComponent.module.scss";
import ButtonComponent from "@/elements/buttonPurpleWhite/ButtonComponent.vue";

export default defineComponent({
  name: "ButtonSimple",
  components: {ButtonComponent},
  props: {
    styleText: {
      type: Object,
      default: {}
    },
    styleButton: {
      type: Object,
      default: {}
    },
    text: String
  },
  data() {
    return {
      style
    };
  }
});
</script>
